export default "__VITE_ASSET__$YL3pxnD__"